'use client'

import React from 'react'
import { RequestServerContext } from '@dustin-web/microsite-config'
import { buildCachedDerivedData } from '@dustin-web/microsite-config/src/build-cached-derived-data'

export type SiteContext = ReturnType<typeof useSiteContext>
const RequestContext = React.createContext<RequestServerContext | null>(null)

export const SiteContextProvider = RequestContext.Provider

export const useSiteContext = () => {
  const context = React.useContext(RequestContext)

  if (!context) {
    throw new Error('useSiteContext must be used within a RequestContext')
  }

  return buildCachedDerivedData(context)
}
